module.exports = __webpack_public_path__ + "static/media/verdeShirt.70f8a0f1.jpg";